import { Component } from '@angular/core';

@Component({
  selector: 'app-login-help',
  templateUrl: './login-help.component.html',
  styleUrls: ['./login-help.component.css']
})
export class LoginHelpComponent {
  public videoFileName: string = 'FirstLogin.mp4';

  get videoUrl(): string {
    return `https://dfxpressstorage.blob.core.windows.net/assetsportal-public/${this.videoFileName}`;
  }
}
